/**
 * Feedback Store - FutJá Admin Panel
 *
 * Gerenciamento centralizado de feedback/toasts/notifications
 */
import { create } from 'zustand'

const TOAST_DURATION = 5000 // 5 segundos

const useFeedbackStore = create((set, get) => ({
	// Estado
	toasts: [],
	loading: false,
	loadingMessage: '',
	sectionLoading: {},

	// Toast Actions
	addToast: (toast) => {
		const id = Date.now() + Math.random()
		const newToast = {
			id,
			type: 'info',
			duration: TOAST_DURATION,
			...toast,
		}

		set((state) => ({
			toasts: [...state.toasts, newToast],
		}))

		// Auto-remove após duration
		if (newToast.duration > 0) {
			setTimeout(() => {
				get().removeToast(id)
			}, newToast.duration)
		}

		return id
	},

	removeToast: (id) => {
		set((state) => ({
			toasts: state.toasts.filter((t) => t.id !== id),
		}))
	},

	clearToasts: () => set({ toasts: [] }),

	// Helpers de toast
	success: (message, options = {}) => {
		return get().addToast({ type: 'success', message, ...options })
	},

	error: (message, options = {}) => {
		return get().addToast({ type: 'error', message, duration: 8000, ...options })
	},

	warning: (message, options = {}) => {
		return get().addToast({ type: 'warning', message, ...options })
	},

	info: (message, options = {}) => {
		return get().addToast({ type: 'info', message, ...options })
	},

	// Loading global
	setLoading: (loading, message = '') => {
		set({ loading, loadingMessage: message })
	},

	// Loading por seção
	setSectionLoading: (section, isLoading) => {
		set((state) => ({
			sectionLoading: { ...state.sectionLoading, [section]: isLoading },
		}))
	},

	isSectionLoading: (section) => {
		return get().sectionLoading[section] || false
	},

	resetSectionLoading: () => set({ sectionLoading: {} }),
}))

export { useFeedbackStore }
export default useFeedbackStore
